import React from 'react';
import { labels } from '../../../../../../util/utils';
import Modal from '../../../../../Common/Modal/Modal';
import styled from 'styled-components';

function DeletionConfirmationModal(props) {

    const clickOnCancel = () => {
		props.setShowModal(false);
    };

    const clickOnConfirm = () => {
		props.setShowModal(false);
		props.ConfirmationCallback();
    };

    return (
        <>
            <Modal
                show={props.showModal}
                title={labels.deletePreviousImport}
                modalContainerClass="importdeletion-modal"
                closeBtnTitle={labels.cancelLabel}
                closeTitle={labels.cancelLabel}
                confirmBtnTitle={labels.delete}
				modalsize={'x-small'}
                onHide={clickOnCancel}
                onOkClick={clickOnConfirm}
                showButtons
                isAresView
            >
                <StyledImportDeletionConfirmationModalBody>
					<span className="import-deletionmsg">{labels.importDeletionConfirmationMsg}</span>
                </StyledImportDeletionConfirmationModalBody>
            </Modal>
        </>
    );
}
export default DeletionConfirmationModal;

const StyledImportDeletionConfirmationModalBody = styled.section`
	.import-deletionmsg {
		display:block;
		font-size: var(--px-14);
		font-weight: normal;
	}
`;
